import { TNameVariant } from 'domains/isni/types';

export const sortNamesByNameAndLang = (names: TNameVariant[]) => [...names].sort((name1, name2) => {
  if (name1.language === name2.language) {
    return (name1.fullname < name2.fullname) ? -1 : (name1.fullname > name2.fullname) ? 1 : 0;
  } else {
    return (name1.language < name2.language || name1.language === null) ? -1 : 1;
  }});